import styled from "styled-components";
import {StripePaymentDashboard, StyledBaseProps} from "@betrue/shared/interfaces";
import {Button, Grid, Link} from "@mui/material";
import {InvoiceListProps} from "@betrue/ui";
import React from "react";

export interface StripDashboardViewProps extends StyledBaseProps, InvoiceListProps {
  data: StripePaymentDashboard,
  total: number
  onPayout: (id: string) => void
}

export const StripDashboardView = styled((props: StripDashboardViewProps) => {

  return (<div className={props.className}>
    <Grid container alignContent={"flex-start"} direction="row" spacing={3} alignItems="flex-start">
      <Grid item>
        <label>{props.totalInvoiceLabel ? props.totalInvoiceLabel : 'Total Facturé'}</label>
        <div> {props.total} €</div>
      </Grid>
      <Grid item>
        <label>{props.stripPendingLabel ? props.stripPendingLabel : 'En transit'}</label>
        <div>
          {props.data?.pending} €
        </div>
      </Grid>
      <Grid item>
        <label>{props.stripeBalanceLabel ? props.stripeBalanceLabel : 'Solde stripe'}</label>
        <div> {props.data?.balance} €</div>
      </Grid>

      <Grid item>
        <Button color={"primary"} variant="contained" disabled={!props.data?.balance} onClick={() => {
          props.onPayout(props.data?.id)
        }}>{props.stripPayoutLabel ? props.stripPayoutLabel : 'Paiement'}</Button>
        <div>
          <Link variant="body2" href={props.data?.loginLink} target={'_blank'}>{props.stripDashboard ? props.stripDashboard : 'dashboard stripe'}</Link>
        </div>


      </Grid>

    </Grid>

  </div>)
})`
  & {
    label {
      color: ${props => props.theme.colors.secondary};
      margin-bottom: 5px;
      display: block;
    }

    button {
      margin-bottom: 5px;

    }
  }
`
